export const APPLICATION_SETTINGS_FETCH = 'APPLICATION_SETTINGS_FETCH';
